import { loginGuard } from "./guards/login.guard";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { LoginComponent } from "./pages/login/login.component";
import { SignUpComponent } from "./pages/sign-up/sign-up.component";
import { Routes } from "@angular/router";

export const AUTH_ROUTES : Routes = [
    {
        path:'',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path:'login',
        component: LoginComponent,
        canActivate: [loginGuard]
    },
    {
        path: 'sign-up',
        component: SignUpComponent,
        canActivate: [loginGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [loginGuard]
    }
];